import MuiForm from "@rjsf/material-ui";

export default MuiForm;
